import { useRef } from 'react'

import axios from 'axios'
import Cookies from 'js-cookie'

import { getWindowId, locale } from 'api/utils'
import { getSubotCookieId, getUserInfoFromCookie } from 'api/utils/cookie'
import { useCurrentUrl } from 'hooks/useCurrentUrl'
import { baseURL, SITE_CODE } from 'hooks/useCustomEventTracking'
import { GA_TOKEN_COOKIE } from 'interfaces/constants'

const getFullname = (elements: HTMLFormControlsCollection) => {
  return (
    Array.from(elements)
      .find((e) => e.getAttribute('inputtype') === 'full_name')
      ?.getAttribute('value') || ''
  )
}
const getEmail = (elements: HTMLFormControlsCollection) => {
  return (
    Array.from(elements)
      .find((e) => e.getAttribute('inputtype') === 'email')
      ?.getAttribute('value') || ''
  )
}
const getPhone = (elements: HTMLFormControlsCollection) => {
  return (
    Array.from(elements)
      .find((e) => e.getAttribute('inputtype') === 'phone')
      ?.getAttribute('value') || ''
  )
}

const useSidisTracking = () => {
  const currentUrl = useCurrentUrl()

  const _trackCloseBabyPoopModal = () => {
    const info = getUserInfoFromCookie()
    const form =
      (document.querySelector('form.friso-form') as HTMLFormElement) || {}
    const formEmail = getEmail(form.elements || [])
    const formName = getFullname(form.elements || [])
    const formPhone = getPhone(form.elements || [])

    axios
      .post(baseURL + '/v1/custom-event/collect', {
        action: 'form-abandoned',
        source: 'leadgen',
        ga_client_id: Cookies.get(GA_TOKEN_COOKIE),
        email: info.email || formEmail || '',
        account_id: info.id,
        site_code: SITE_CODE[locale],
        timestamp: new Date().toISOString(),
        data: {
          timestamp: new Date().toISOString(),
          page_url: currentUrl,
          window_id: getWindowId(),
          cookie_id: getSubotCookieId(),
          client_agent: navigator?.userAgent || '',
          token: localStorage.getItem('fcm_token'),
          email: info.email || formEmail || '',
          name: formName,
          phone: formPhone,
          account_id: info.id,
          campaign_id: 4531, // campaign id of lead gen tool for baby poop
          campaign_name: '[Production] Friso Project',
        },
      })
      .catch(console.log)
  }
  const trackCloseBabyPoopModal = useRef(_trackCloseBabyPoopModal)

  return { trackCloseBabyPoopModal: trackCloseBabyPoopModal.current }
}

export { useSidisTracking }
